import Vue from "vue";
import VueRouter from "vue-router";

// 注册 vue-router（需在 VueRouter 实例创建之前调用）
Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

// 引入组件 HomeView
import IndexView from "../views/home/index.vue";
import CartView from "../views/cart/index.vue";
import LoginView from "../views/common/login.vue";
import ArticelView from "../views/common/articel.vue";
import ContactUsView from "../views/common/contactUs.vue";
import BlogView from "../views/common/blog.vue";
import BlogDetailView from "../views/common/blogDetail.vue";
import designServiceView from "../views/common/designService.vue";

//商品
import ProductView from "../views/product/detail.vue";
import CategoryView from "../views/product/category.vue";
import CheckoutView from "../views/order/checkout.vue";
import QuotesView from "../views/product/quotes.vue";
import OrderView from "../views/order/index.vue";
import OrderDetailView from "../views/order/detail.vue";
import SearchResultView from "../views/product/searchResult.vue";
import paySuccessView from "../views/pay/paySuccess.vue";

//usercenter
import UserView from "../views/user/index.vue";
import PasswordView from "../views/user/password.vue";
import AddressView from "../views/address/index.vue";
import payMethodView from "../views/user/paymethod.vue";
import resetPwdView from "../views/common/resetPwd.vue";

// 设置路由规则
const routes = [{
		path: "/", // 设置路由路径
		name: "home", // 设置组件名称（可选）
		component: IndexView, // 注册组件
	},
	{
		path: "/cart", // 设置路由路径
		name: "cart", // 设置组件名称（可选）
		component: CartView, // 注册组件
	},
	{
		path: "/login", // 设置路由路径
		name: "login", // 设置组件名称（可选）
		component: LoginView, // 注册组件
	},
	{
		path: "/product", // 设置路由路径
		name: "product", // 设置组件名称（可选）
		component: ProductView, // 注册组件
	},
	{
		path: "/category", // 设置路由路径
		name: "category", // 设置组件名称（可选）
		component: CategoryView, // 注册组件
	},
	{
		path: "/user", // 设置路由路径
		name: "user", // 设置组件名称（可选）
		component: UserView, // 注册组件
	},
	{
		path: "/password", // 设置路由路径
		name: "password", // 设置组件名称（可选）
		component: PasswordView, // 注册组件
	},
	{
		path: "/address", // 设置路由路径
		name: "address", // 设置组件名称（可选）
		component: AddressView, // 注册组件
	},
	{
		path: "/paymethod", // 设置路由路径
		name: "paymethod", // 设置组件名称（可选）
		component: payMethodView, // 注册组件
	},
	{
		path: "/checkout", // 设置路由路径
		name: "checkout", // 设置组件名称（可选）
		component: CheckoutView, // 注册组件
	},
	{
		path: "/quotes", // 设置路由路径
		name: "quotes", // 设置组件名称（可选）
		component: QuotesView, // 注册组件
	},
	{
		path: "/article", // 设置路由路径
		name: "article", // 设置组件名称（可选）
		component: ArticelView, // 注册组件
	},
	{
		path: "/order", // 设置路由路径
		name: "order", // 设置组件名称（可选）
		component: OrderView, // 注册组件
	},
	{
		path: "/orderDetail", // 设置路由路径
		name: "orderDetail", // 设置组件名称（可选）
		component: OrderDetailView, // 注册组件
	},
	{
		path: "/blog", // 设置路由路径
		name: "blog", // 设置组件名称（可选）
		component: BlogView, // 注册组件
	},
	{
		path: "/blogDetail", // 设置路由路径
		name: "blogDetail", // 设置组件名称（可选）
		component: BlogDetailView, // 注册组件
	},
	{
		path: "/search", // 设置路由路径
		name: "search", // 设置组件名称（可选）
		component: SearchResultView, // 注册组件
	},
	{
		path: "/designService", // 设置路由路径
		name: "designService", // 设置组件名称（可选）
		component: designServiceView, // 注册组件
	},
	{
		path: "/payment-success", // 设置路由路径
		name: "payment-success", // 设置组件名称（可选）
		component: paySuccessView, // 注册组件
	},
	{
		path: "/contact-us", // 设置路由路径
		name: "contact-us", // 设置组件名称（可选）
		component: ContactUsView, // 注册组件
	},
	{
		path: "/reset-password", // 设置路由路径
		name: "reset-password", // 设置组件名称（可选）
		component: resetPwdView, // 注册组件
	}
];

const router = new VueRouter({
	base: process.env.BASE_URL,
	mode: 'history',
	routes,
	scrollBehavior(to, from, savePosition) {
		return {
			top: 0
		};
	}
}); // 创建 VueRouter 实例

export default router; // 导出 VueRouter 实例
